import i18n from "../locales/i18n";

const SUPPORTED_LANGS = ["ko", "en"] as const;

export type SupportedLng = (typeof SUPPORTED_LANGS)[number];

export const getCurrentLng = (): SupportedLng => {
  const raw = i18n.language;
  if (raw.startsWith("ko")) return "ko";
  if (raw.startsWith("en")) return "en";
  return "ko";
};
